import { all, spawn } from 'redux-saga/effects';
import {
  invitationsSaga,
  notificationsSaga,
  userSaga,
  summarySaga,
  imagesSaga,
  compareSaga,
} from '@prometheus/redux';

const rootSaga = function* () {
  yield all([
    spawn(notificationsSaga),
    spawn(invitationsSaga),
    spawn(userSaga),
    spawn(summarySaga),
    spawn(imagesSaga),
    spawn(compareSaga),
  ]);
};

export default rootSaga;
